import uniq from "lodash-es/uniq";
import { MathUtils } from "./Math/MathUtils";

export class ArrayUtils {
    static GetRandomElement<TElement>(array: TElement[]) {
        const randomIndex = MathUtils.RandomNumberBetween(0, array.length - 1);
        const randomElement = array[randomIndex];
        return randomElement;
    }

    static Exclude<TElement>(array: TElement[], toExclude: TElement) {
        return array.filter(
            (elem) => JSON.stringify(elem) !== JSON.stringify(toExclude)
        );
    }

    static ExcludeByPropertyValue<TElement>(
        array: TElement[],
        propertyName: string,
        propertyValue: any
    ) {
        return array.filter(
            (elem: any) => elem[propertyName] !== propertyValue
        );
    }

    static AddToWithoutRepeating<TElement>(array: TElement[], toAdd: TElement) {
        return [...array.filter((elem) => elem !== toAdd), toAdd];
    }

    static AddRangeToWithoutRepeating<TElement>(
        array: TElement[],
        toAdd: TElement[]
    ) {
        const arrayWithoutNewElements = array.filter(
            (elem) => !toAdd.includes(elem)
        );

        const result = [...arrayWithoutNewElements, ...toAdd];
        return result;
    }

    static ConvertToHtml<TElement>(array: TElement[], className: string) {
        const arrayHTML = uniq(array)
            .sort()
            .map((gn) => `<div class="${className}>${gn}</div>`)
            .join("");

        return arrayHTML;
    }

    static SelectMany<TIn, TOut>(
        input: TIn[],
        selectListFn: (t: TIn) => TOut[]
    ): TOut[] {
        return input.reduce((out, inx) => {
            out.push(...selectListFn(inx));
            return out;
        }, new Array<TOut>());
    }
}
